var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawPettingXclp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640.19,
    height: 499.032,
    viewBox: "0 0 640.19 499.032",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-640 -290)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(695.577 517.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.888,246.151c-2.807,13.471-18.8-3.087-18.8-3.087L453,240.818s-12.068.281-19.926,6.455-13.191-1.965-13.191-1.965c-8.853,2.951-19.7,2.939-29.094,1.994a29.47,29.47,0,0,1-26.247-25.287c-10.495-76.024,47.2-113.384,47.2-113.384l16.839-45.466s-5.332-13.191-7.016-24.978,10.665-23.013,25.82-34.239c6.63-4.911,14.228-4.558,20.677-2.607A36.806,36.806,0,0,1,486.272,13.98c3.863,4.928,10.489,11.908,17.773,13.117a15.932,15.932,0,0,1,7.331,3.233c2.4,1.88,3.463,5.018,3.5,8.919.18,17.041-13.892,37.557-26.23,40.756-15.155,3.929-7.016,41.256-7.016,41.256,24.7,34.8,7.3,73.531,7.3,73.531l4.49,31.433s.281,6.455-2.526,19.926Z",
    transform: "translate(-334.304 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.234,305.587l6.174,76.9s-8.42,21.33,20.207,20.207,11.787-44.9,11.787-44.9l-8.981-57.253",
    transform: "translate(-402.162 -131.844)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.005,402.858q1.05,0,2.152-.043c6.337-.248,11-2.582,13.87-6.937,8.2-12.451-.92-36.993-1.559-38.673L505.5,300.009a.562.562,0,0,0-1.109.174l8.981,57.253a.591.591,0,0,0,.031.115c.1.254,9.683,25.57,1.69,37.71-2.656,4.034-7.022,6.2-12.976,6.431-9.347.365-15.634-1.63-18.69-5.932-4-5.629-1-13.43-.972-13.508a.567.567,0,0,0,.037-.25l-6.174-76.9a.561.561,0,1,0-1.119.09l6.164,76.772c-.408,1.1-2.965,8.646,1.144,14.439C485.544,400.69,491.427,402.858,500.005,402.858Z",
    transform: "translate(-401.681 -131.405)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.368,337.535s-1.684,71.285,33.678,69.6S409.414,383,409.414,383l-3.087-8.7",
    transform: "translate(-247.217 -148.076)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.4,407.288c.411,0,.823-.01,1.24-.03,10.1-.481,15.8-2.743,16.956-6.724,2.079-7.173-11.473-17.132-13.145-18.328l-3.028-8.532a.561.561,0,0,0-1.058.375l3.087,8.7a.559.559,0,0,0,.207.272c.148.1,14.806,10.488,12.859,17.2-1.006,3.469-6.366,5.459-15.931,5.914A21.46,21.46,0,0,1,389,399.778c-17.373-16.96-16.514-62.214-16.5-62.669a.562.562,0,0,0-.548-.574.578.578,0,0,0-.575.548c-.044,1.878-.883,46.194,16.841,63.5A22.494,22.494,0,0,0,404.4,407.288Z",
    transform: "translate(-246.787 -147.637)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.136,60.427c-4.03.483-10.339.46-15.565-3.025-5.6-3.733.213-7.213,4.737-9.127a15.932,15.932,0,0,1,7.331,3.233C380.041,53.388,381.1,56.526,381.136,60.427Z",
    transform: "translate(-200.567 -21.178)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.421,32S505.216,6.849,491.188,6.5s-25.108,21.447-25.108,21.447-35.209,64.181,13.03,60.72S504.3,59.583,504.3,59.583s-11-13.527-8.876-27.578h0Z",
    transform: "translate(-379.98 -2.848)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633,369.985c-6.212,2.764-12.7,5.584-19.5,5.314s-13.944-4.645-15-11.362c-.547-3.467.537-7.187-.79-10.436-1.786-4.372-7.548-6.058-12.026-4.56s-7.769,5.361-10.128,9.453c-4.414,7.654-6.182,17.7-1.45,25.162,4.1,6.468,11.883,9.391,19.121,11.9,9.641,3.339,20.4,6.654,29.746,2.552,9.4-4.125,14.513-16.044,11.034-25.7",
    transform: "translate(-571.295 -152.845)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.721,422.562H640.19v-3.027H.721c-.4,0-.721.678-.721,1.514H0C0,421.885.323,422.562.721,422.562Z",
    transform: "translate(640 338.313)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.154,723.123c0,.091-.288.242-.817.454-8.552,3.482-81.453,22.343-90.006,23.765-9.082,1.514-45.412-4.541-52.98-19.678s39.357-19.678,39.357-19.678l16.651-16.651,2.361-12.609,2.18-11.61L820.558,698.9S831.154,721.609,831.154,723.123Z",
    transform: "translate(325.03 32.898)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.725,587.116l-10.6,6.055s-36.329,27.247-24.22,39.357,30.274-22.706,30.274-22.706l10.6-7.569Z",
    transform: "translate(264.367 -8.199)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.87,
    cy: 40.87,
    r: 40.87,
    transform: "translate(938.209 350.346)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.667,454.116s49.953,13.623,54.494,12.11L726.023,520.72s-42.384-28.761-49.953-28.761Z",
    transform: "translate(319.66 -76.523)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.071,506.555s22.706-48.439,28.761-48.439,80.227,4.541,116.556,57.521S873.717,588.3,873.717,588.3l-98.392,24.219-3.027-3.027s-27.247,7.569-43.9-30.274Z",
    transform: "translate(327.879 -74.469)",
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.34,476.139s-30.274-3.027-51.466,31.788-63.576,65.09-63.576,65.09l-80.227,71.145,9.082,21.192,95.364-57.521,110.5-77.2S823.183,485.221,785.34,476.139Z",
    transform: "translate(275.48 -65.244)",
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.393,597.958,771.825,713s-8.84-5.207-22.191-13.517c-32.167-20.026-90.505-58.127-114.043-84.874-27.2-30.91,6.206-47.7,19.345-52.783,2.952-1.15,4.874-1.711,4.874-1.711Z",
    transform: "translate(293.536 -22.07)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.064,723.123c0,.091-.288.242-.817.454-34.271-3.527-62.426-22.055-84.617-44.852l2.18-11.61L800.468,698.9S811.064,721.609,811.064,723.123Z",
    transform: "translate(345.119 32.898)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.47,563.308v10.6s-6.055-3.027-3.027,3.027l-1.514,4.541-31.788,4.541S655.667,551.2,645.071,567.849l16.651,80.227,43.9-12.11s65.09,186.187,201.325,140.776l1.514-6.055,27.247-6.055s-19.678-214.948-36.329-222.517Z",
    transform: "translate(303.734 -31.316)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 113.529,
    transform: "translate(1206.787 614.73)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    y1: 25.733,
    x2: 81.741,
    transform: "translate(1020.6 573.859)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    y1: 123.316,
    x2: 56.657,
    transform: "translate(1094.122 585.969)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.3,448.355c6.918-4.464,13.765-9.98,21.849-10.772,10.606-1.038,19.86,6.363,27,14.092s13.962,16.594,23.945,19.973c5.8,1.964,12.119,1.849,18.222,2.633s12.487,2.766,16.126,7.691c3.8,5.146,3.727,12.19,5.406,18.425,3.953,13.719,25.9,23.224,23.237,23.664-10.329,1.7-20.274,8.272-29.639,14.32-11.463,7.4-24.751,14.633-37.753,11.644-13.259-3.048-21.867-15.782-34.2-21.415-10.541-4.816-22.758-4.031-34.41-4.811s-24.335-4-30.556-13.812c-4.59-7.241-5.507-17.718-13.152-21.54-4.729-2.364-10.429-1.21-15.765-1.306s-11.582-2.581-12.2-7.915c13.742-7.5,27.35-15.416,41.283-22.527C680.3,452.313,695.627,457.332,702.3,448.355Z",
    transform: "translate(296.207 -85.068)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.152,504.519s69.426-34.713,69.426-47.111-27.275-49.59-76.865-49.59c0,0-12.4-22.316-27.275-4.959s7.438,29.754,7.438,29.754-27.275,44.631,12.4,71.906Z",
    transform: "translate(289.48 -106.25)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7,
    cy: 6.5,
    rx: 7,
    ry: 6.5,
    transform: "translate(824 535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(828 535)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(833 537)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPettingXclp);
export default __webpack_public_path__ + "static/media/undraw_petting_xclp.09919151af763139b54c4fe5402413de.svg";
export { ForwardRef as ReactComponent };